import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";
//Include Both Helper File with needed methods
import { formatQueryParams } from "helpers/format";
import agencyApi from "api/agencyApi";

export const getAgencyCampaignList = createAsyncThunk(
  "AgencyCampaign",
  async (params: any = {}) => {
    try {
      const response = await agencyApi.agencyCampaignList(
        formatQueryParams(params)
      );
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const getCampaignDetail =  async(id: string | number ,  params: any = {}) => {
  try{
    const response = await agencyApi.getAgencyCampaignDetail(id, params)
    return response;
  }catch (error) {
    return error;
  }
};

export const postCampaign = async (data: any = {}) => {
  try{
    const response = await agencyApi.createAgencyCampaign(data);
    return response;
  }catch (error) {
    return error;
  }
};

export const putCampaign = async (id: string | number , data: any = {}) => {
  try{
    const response = await agencyApi.updateAgencyCampaign(id, data);
    return response;
  }catch (error) {
    return error;
  }
};